import React, { useEffect, useState } from "react";
import "./style.css";

export const Screen = () => {
  const baseImgUrl = 'https://storage.googleapis.com/image-generator-ai-output-bucket/output/'
  const baseLineUrl = 'http://line.me/R/msg/text/?'
  const baseXUrl = 'https://twitter.com/intent/tweet?hashtags=アイレット株式会社&text=世界のお祭りに、生成AIで参加してみました！&url='
  const baseFbUrl = 'https://www.facebook.com/share.php?u='
  const params = new URLSearchParams(window.location.search);
  const encodedImage = params.get("img");
  const decodedImage = atob(encodedImage);
  const imgList = decodedImage.split('/')
  
  return (
    <div className="screen">
      <header className="header">
        <img className="iret-logo-white" alt="Iret logo white" src="/img/iret-logo-white-1.svg" />
      </header>
      <div className="overlap-group">
        <div className="div">Thank you for coming!</div>
        <div className="text-wrapper">
          来場の記念に生成した画像を
          <br />
          プレゼントいたします！
        </div>
        <div className="text-wrapper-2">シェアする</div>
        <div className="share-button">
          <a
          href={baseLineUrl + window.location.href}
          target="_blank"
          rel="noopener noreferrer"
          >
            <img className="sharebutton-LINE" alt="Sharebutton LINE" src="/img/sharebutton-line.svg" />
          </a>
          <a
          href={baseXUrl + window.location.href}
          target="_blank"
          rel="noopener noreferrer"
          >
            <div className="sharebutton-x">
              <img className="vector" alt="Sharebutton X" src="/img/sharebutton-x.svg" />
            </div>
          </a>
          <a
          href={baseFbUrl + window.location.href}
          target="_blank"
          rel="noopener noreferrer"
          >
            <img className="sharebutton-facebook" alt="Sharebutton facebook" src="/img/sharebutton-facebook.png" />
          </a>
        </div>
        {
          imgList.map((path,v) => {
            const imgUrl = baseImgUrl + path
            return (
              <div>
                <div className="element">
                  <img className="img" alt="Element" src={imgUrl} />
                </div>
              </div>
            )
          })
        }
        <div className="p25"></div>
      </div>
    </div>
  );
};
